import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface FloatingMenuProps {
    actions: {
        title: string;
        icon: IconDefinition;
        fn: () => void;
    }[];
    className: string;
}

export const FloatingMenu = (props: FloatingMenuProps) => (
    <div
        className={`rounded bg-white flex items-center gap-1 z-50 border p-0.5 ${props.className}`}
    >
        {props.actions.map((action) => (
            <button
                key={`${action.title}_${action.icon.iconName}`}
                type="button"
                onClick={action.fn}
                className="hover:bg-neutral-200 rounded flex items-center justify-center p-1"
            >
                <FontAwesomeIcon icon={action.icon} className="" />
            </button>
        ))}
    </div>
);
